import { colors } from '@airship-platform/jam-design-tokens';
import { PaletteColorOptions, PaletteOptions } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Palette {
    tertiary?: PaletteColorOptions;
    red?: PaletteColorOptions;
    gray?: PaletteColorOptions;
    blue?: PaletteColorOptions;
    green?: PaletteColorOptions;
    white?: PaletteColorOptions;
    gold?: PaletteColorOptions;
    softRed?: PaletteColorOptions;
    softGray?: PaletteColorOptions;
    softBlue?: PaletteColorOptions;
    softGreen?: PaletteColorOptions;
    softGold?: PaletteColorOptions;
  }
  interface PaletteOptions {
    tertiary?: PaletteColorOptions;
    red?: PaletteColorOptions;
    gray?: PaletteColorOptions;
    blue?: PaletteColorOptions;
    green?: PaletteColorOptions;
    white?: PaletteColorOptions;
    gold?: PaletteColorOptions;
    softRed?: PaletteColorOptions;
    softGray?: PaletteColorOptions;
    softBlue?: PaletteColorOptions;
    softGreen?: PaletteColorOptions;
    softGold?: PaletteColorOptions;
  }
  interface PaletteColor {
    50?: string;
    100?: string;
    200?: string;
    300?: string;
    400?: string;
    500?: string;
    600?: string;
    700?: string;
    800?: string;
    900?: string;
  }
  interface SimplePaletteColorOptions {
    50?: string;
    100?: string;
    200?: string;
    300?: string;
    400?: string;
    500?: string;
    600?: string;
    700?: string;
    800?: string;
    900?: string;
  }
  interface TypeText {
    primary: string;
    secondary: string;
    disabled: string;
    tertiary?: string;
  }
}

export const basePalette: PaletteOptions = {
  common: {
    black: '#000000',
    white: '#ffffff',
  },
  success: {
    main: colors.blue[600],
    dark: colors.blue[600],
    light: colors.blue[200],
    contrastText: colors.blue[600],
  },
  text: {
    primary: colors.text.primary,
    secondary: colors.text.secondary,
    tertiary: colors.text.tertiary,
  },
  background: {
    default: colors.gold[50],
  },
  primary: {
    ...colors.red,
    main: colors.red[500],
    dark: colors.red[600],
    light: colors.red[400],
    contrastText: colors.common.white,
  },
  secondary: {
    ...colors.gold,
    main: colors.gold[600],
    dark: colors.gold[700],
    light: colors.gold[400],
    contrastText: colors.common.white,
  },
  tertiary: {
    ...colors.blue,
    main: colors.blue[500],
    dark: colors.blue[600],
    light: colors.blue[50],
    contrastText: colors.common.white,
  },
  blue: {
    ...colors.blue,
    main: colors.blue[500],
    dark: colors.blue[600],
    light: colors.blue[50],
    contrastText: colors.common.white,
  },
  gray: {
    ...colors.gray,
    main: colors.gray[700],
    dark: colors.gray[800],
    light: colors.gray[700],
    contrastText: colors.common.white,
  },
  red: {
    ...colors.red,
    main: colors.red[300],
    dark: colors.red[700],
    light: colors.red[600],
    contrastText: colors.common.black,
  },
  green: {
    ...colors.green,
    main: colors.green[300],
    dark: colors.green[400],
    light: colors.green[200],
    contrastText: colors.common.black,
  },
  white: {
    ...colors.common,
    main: colors.common.white,
    dark: colors.common.white,
    light: colors.common.white,
    contrastText: colors.gold[700],
  },
  gold: {
    ...colors.gold,
    main: colors.gold[300],
    dark: colors.gold[400],
    light: colors.gold[300],
    contrastText: colors.gold[700],
  },
  softGreen: {
    ...colors.green,
    main: colors.green[50],
    dark: colors.green[100],
    light: colors.green[200],
    contrastText: colors.green[700],
  },
  softGold: {
    ...colors.gold,
    main: colors.gold[50],
    dark: colors.gold[100],
    light: colors.gold[200],
    contrastText: colors.gold[700],
  },
  softRed: {
    ...colors.red,
    main: colors.red[50],
    dark: colors.red[100],
    light: colors.red[200],
    contrastText: colors.red[700],
  },
  softGray: {
    ...colors.gray,
    main: colors.gray[50],
    dark: colors.gray[100],
    light: colors.gray[50],
    contrastText: colors.gray[700],
  },
  softBlue: {
    ...colors.blue,
    main: colors.blue[50],
    dark: colors.blue[100],
    light: colors.blue[50],
    contrastText: colors.blue[600],
  },
  action: {
    disabled: colors.gray[300],
    disabledBackground: colors.gray[50],
  },
};
